/**
 * Get the average temperature from the probe data
 * @param probeData
 */
export const averageTemperature = (probeData: Array<common.ProbeData>) => {
  const total = probeData.map((x) => x.temperature).reduce((a, b) => a + b);

  return (total / probeData.length).toFixed(2);
};

/**
 * Get the average humidity from the probe data
 * @param probeData
 */
export const averageHumidity = (probeData: Array<common.ProbeData>) => {
  const total = probeData.map((x) => x.humidity).reduce((a, b) => a + b);

  return (total / probeData.length).toFixed(2);
};

/**
 * Get the latest temperature reading from the probe data
 * @param probeData
 */
export const latestTemperature = (probeData: Array<common.ProbeData>) =>
  probeData[0].temperature.toFixed(2);

/**
 *
 * @param probeData
 */
export const latestHumidity = (probeData: Array<common.ProbeData>) =>
  probeData[0].humidity.toFixed(2);

export const isTooHot = (probe: common.Probe): boolean =>
  (probe.probeData && probe.probeData.length
    ? probe.probeData[0].temperature
    : probe.latestTemperature) > probe.maximumTemperature;

export const isTooCold = (probe: common.Probe): boolean =>
  (probe.probeData && probe.probeData.length
    ? probe.probeData[0].temperature
    : probe.latestTemperature) < probe.minimumTemperature;

export const isTooDry = (probe: common.Probe): boolean =>
  (probe.probeData && probe.probeData.length
    ? probe.probeData[0].humidity
    : probe.latestHumidity) < probe.minimumHumidity;

export const isTooWet = (probe: common.Probe): boolean =>
  (probe.probeData && probe.probeData.length
    ? probe.probeData[0].humidity
    : probe.latestHumidity) > probe.maximumHumidity;
